<script>
  import { onDestroy } from 'svelte';
  import { update_search } from "./Utils/RouterUtils.svelte";
  import {reset_url, update_video} from "./Utils/RouterUtils.svelte"
  import {search_store, active_video_store, normalized_video_store} from "./Utils/stores";
  import {store} from "./Utils/stores";
  import Debug from "./Utils/Debug.svelte";
  import VideoPlayerModal from "./VideoPlayerModal.svelte";
  import SingleVideoTile from "./SingleVideoTile.svelte";
    import CategoryMainPanel from "./CategoryMainPanel.svelte";
    import CategoryContainer from "./CategoryContainer.svelte";    
    import CategoryContainerHeader from "./CategoryContainerHeader.svelte";
    import CategoryContainerBody from "./CategoryContainerBody.svelte";
    import CategorySidebar from "./CategorySidebar.svelte";
    import CategorySidebarTitle from "./CategorySidebarTitle.svelte";
    import CategorySidebarDescription from "./CategorySidebarDescription.svelte";
    import CategoryGrid from "./CategoryGrid.svelte";

  export let product = product;
  switch(product) {
  case "vcarve_pro":
  product = "VCarve Pro"
    break;
  case "vcarve_desktop":
  product = "VCarve Desktop"
    break;
  case "cut2d_pro":
  product = "Cut2D Pro"
    break;
  case "cut2d_desktop":
  product = "Cut2D Desktop"
    break;
  }

  function handleVideoClick(video) {
    update_video(video)
  }
  let search_term = '';
  
  let normalizedResults = [];
  const unsub_search = search_store.subscribe(() => {
    normalizedResults = $search_store.results.map(video_slug => {
      return $normalized_video_store.videos[video_slug.slug];
    }).filter(video => {
      return video;
    });
  });
  onDestroy(unsub_search);


  const unsubscribe = store.subscribe(value => {
    search_term = '';

    normalizedResults = $search_store.results.map(video_slug => {
      return $normalized_video_store.videos[video_slug.slug];
    }).filter(video => {
      return video;
    });

  });
  onDestroy(unsubscribe);

  function handle_submit(evt) {
      update_search(search_term);
  }
  function getProductName() {
    if(product) {
      return product;
    }
    return "All"
  }



</script>

<CategoryContainer id="categoryTop">
  <CategoryContainerHeader>
    <div class="vec-flex vec-items-center vec-text-sm">
      <a on:click={reset_url} class="vec-cursor-pointer vec-text-darkGrey hover:vec-text-black hover:vec-underline">Tutorials</a> 
        <svg xmlns="http://www.w3.org/2000/svg" width="5.207" height="9.414" viewBox="0 0 5.207 9.414" class="vec-mx-3">
          <path id="BC_Divider" data-name="BC Divider" d="M1,1,5,5,9,1" transform="translate(-0.293 9.707) rotate(-90)" fill="none" stroke="#666" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        </svg>
        Search
    </div>
  </CategoryContainerHeader>
  <CategoryContainerBody>
    {#if normalizedResults.length > 0}
    <CategorySidebar>
      <CategorySidebarTitle>
        {normalizedResults.length} search result{#if normalizedResults.length > 1}s{/if} for "<span class="vec-italic">{$store.search}</span>"
      </CategorySidebarTitle>
    </CategorySidebar>
    {/if}
    {#if normalizedResults.length == 0 && !$search_store.searching}
    <CategorySidebar>
      <CategorySidebarTitle>No videos found matching "<span class="vec-italic">{$store.search}</span>"</CategorySidebarTitle>
      <CategorySidebarDescription>
          Try an alternative search term or <a on:click={reset_url} class="vec-cursor-pointer vec-underline">view all tutorials</a>
      </CategorySidebarDescription>
        <form
          on:submit|preventDefault={handle_submit}>
          <div class="vec-justify-content-center vec-mx-auto vec-mt-10 vec-flex vec-max-w-screen-md">
            <div class="vec-relative vec-flex vec-w-full vec-justify-center md:vec-mx-auto">
              <input type="search" name="search" id="search" bind:value={search_term}
                class="vec-outline-none vec-h-12 vec-w-full vec-rounded-md vec-rounded-bl-none vec-border vec-border-midGrey vec-px-2 vec-capitalize vec-text-black focus:vec-ring-4 focus:vec-ring-black/10" placeholder="Search {getProductName()} videos...">
              <button type="submit" class="vec-absolute vec-right-0 vec-top-0 vec-flex vec-h-12 vec-w-12 vec-rounded-r-md vec-border vec-border-l-0 vec-border-midGrey vec-bg-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.973" viewBox="0 0 20 19.973" class="vec-m-auto">
                  <path d="M25.343,16.888A8.122,8.122,0,0,1,23.539,22l5.481,5.481L27.8,28.7,22.33,23.218a8.161,8.161,0,1,1,3.013-6.33m-8.161-6.443a6.443,6.443,0,1,0,6.443,6.443,6.443,6.443,0,0,0-6.443-6.443" transform="translate(-9.02 -8.723)" fill-rule="evenodd" fill="#000"/>
                </svg>        
                <span class="sr-only">Search</span>
              </button>
            </div>
          </div>
        </form>
    </CategorySidebar>
    {:else}
    <CategoryMainPanel>
      <CategoryGrid>
    {#each normalizedResults as video (video.slug.current)}
      <SingleVideoTile video={video}
        on:click={() => handleVideoClick(video.slug.current)}/>
      {/each}
      </CategoryGrid>
    </CategoryMainPanel>
    {/if}
    </CategoryContainerBody>
  </CategoryContainer>
